import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.q6r_1 = partyId;
        this.r6r_1 = pinId;
        this.s6r_1 = icon;
        this.t6r_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.q6r_1.toString() + ', pinId=' + this.r6r_1.toString() + ', icon=' + this.s6r_1 + ', name=' + this.t6r_1 + ')';
      }
      hashCode() {
        var result = this.q6r_1.hashCode();
        result = imul(result, 31) + this.r6r_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.s6r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t6r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.q6r_1.equals(other.q6r_1))
          return false;
        if (!this.r6r_1.equals(other.r6r_1))
          return false;
        if (!(this.s6r_1 === other.s6r_1))
          return false;
        if (!(this.t6r_1 === other.t6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
